import { render } from "./order_cancel.vue?vue&type=template&id=6631ee02"
import script from "./order_cancel.vue?vue&type=script&lang=js"
export * from "./order_cancel.vue?vue&type=script&lang=js"

import "./order_cancel.vue?vue&type=style&index=0&id=6631ee02&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__